import { memo, useCallback } from "react";
import { classNames, transformRoute, useTranslate } from "helpers";

import { TableRowChildProps } from "ui/components/Table/TableSearch/types";
import { TIRE_TYPE_BACKGROUND } from "../consts";
import { useNavigate } from "react-router-dom";
import { Routes as FleetTireRoutes } from "ui/modules/fleet/tires/navigation";

const TireRowChild: React.FC<TableRowChildProps> = (props) => {
  const { index, row } = props;

  const { t } = useTranslate();
  const navigate = useNavigate();

  const handleRowClick = useCallback(
    (rowId: string) => (event: React.MouseEvent<unknown>) => {
      event.stopPropagation();
      event.preventDefault();

      navigate(
        transformRoute(FleetTireRoutes.FleetTireDetailPageRouter, {
          id: rowId,
        })
      );
    },
    [navigate]
  );

  return (
    <>
      <tr
        key={index}
        className={classNames(
          "hover:bg-slate-100",
          index % 2 === 0 ? "bg-white" : " bg-slate-50"
        )}
        onClick={handleRowClick(row.id)}
      >
        <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
          {row.width}/{row.height} R{row.radius}
        </td>
 <td className={classNames("px-4 py-3 text-sm font-medium gap-2 flex items-center")}>
          {row.tireType && TIRE_TYPE_BACKGROUND(row.tireType?.id)} <div className="text-md">{row.tireType?.name}</div>
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.tireManufacturer?.name}
        </td>
       
   
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.dot}
        </td>
        <td className={classNames("px-4 py-3 text-sm font-medium")}>
          {row.profileDepth && `${row.profileDepth} cm`}
        </td>
      </tr>
    </>
  );
};

export default memo(TireRowChild);
